var _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSortIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4287 19H10.5477C10.2743 19 10.0312 19.2376 10.0312 19.505V21.495C10.0312 21.7624 10.2743 22 10.5477 22H23.4591C23.7325 22 23.9756 21.7624 23.9756 21.495V19.505C23.9452 19.2079 23.7021 19 23.4287 19Z",
    fill: "url(#paint0_linear_0:1477)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4481 13H10.5468C10.243 13 10 13.2079 10 13.505V15.495C10 15.7624 10.243 16 10.5165 16H19.4177C19.6911 16 19.9342 15.7624 19.9342 15.495V13.505C19.9646 13.2079 19.7215 13 19.4481 13Z",
    fill: "url(#paint1_linear_0:1477)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.168 7H10.5477C10.2743 7 10.0312 7.23762 10.0312 7.50495V9.49505C10.0312 9.76238 10.2743 10 10.5477 10H16.1983C16.4718 10 16.7148 9.76238 16.7148 9.49505V7.50495C16.7148 7.20792 16.4718 7 16.168 7Z",
    fill: "url(#paint2_linear_0:1477)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9173 1H10.5477C10.2743 1 10.0312 1.23762 10.0312 1.50495V3.49505C10.0312 3.76238 10.2743 4 10.5477 4H12.9477C13.2211 4 13.4642 3.76238 13.4642 3.49505V1.50495C13.4338 1.23762 13.2211 1 12.9173 1Z",
    fill: "url(#paint3_linear_0:1477)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.15312 5.38235L4.44679 0.176471C4.29489 -0.0588235 3.96071 -0.0588235 3.80881 0.176471L0.0721048 5.38235C-0.110174 5.64706 0.0721048 5.97059 0.406282 5.97059H2.53286V21.4706C2.53286 21.7647 2.7759 22 3.0797 22H5.14552C5.44932 22 5.69236 21.7647 5.69236 21.4706V5.97059H7.81894C8.15312 5.97059 8.3354 5.61765 8.15312 5.38235Z",
    fill: "url(#paint4_linear_0:1477)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0:1477",
    x1: 30.9477,
    y1: 20.5,
    x2: 29.714,
    y2: 14.7654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB438"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0:1477",
    x1: 24.9051,
    y1: 14.5,
    x2: 23.245,
    y2: 9.00121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB438"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_0:1477",
    x1: 20.0566,
    y1: 8.5,
    x2: 17.815,
    y2: 3.50615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB438"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_0:1477",
    x1: 15.1806,
    y1: 2.5,
    x2: 12.2077,
    y2: -0.901958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB438"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_0:1477",
    x1: 12.3378,
    y1: 11,
    x2: -2.09515,
    y2: 5.60389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB438"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9F00"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortIcon);
export default __webpack_public_path__ + "static/media/sort_icon.aaaa9d39.svg";
export { ForwardRef as ReactComponent };